import { render, staticRenderFns } from "./VehicleDialog.vue?vue&type=template&id=71e5c13d&"
import script from "./VehicleDialog.vue?vue&type=script&lang=ts&"
export * from "./VehicleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports